<template>
  <button :class="classes">
    <span
      class="ui-search-bar-button__button ui-search-bar-button__button--search"
    >
      <IconSearch />
    </span>

    <span class="ui-search-bar-button__text">
      {{ $t('component.search-button.label') }}
    </span>

    <!-- <input class="ui-search-bar-button__text" placeholder="Search for upcoming events" v /> -->

    <!-- <span class="ui-search-bar-button__button ui-search-bar-button__button--filters">
      <IconFilter />
    </span> -->
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import IconSearch from './icons/IconSearch.vue'

const classes = computed(() => ({
  'ui-search-bar-button': true,
}))
</script>

<style lang="scss">
@import '../styles/config';

.ui-search-bar-button {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.25rem;
  background-color: $white;
  border: 1px solid $black;
  border-radius: 0.25rem;
  @include transition('color, background-color');

  & > * {
    margin-right: 0.75rem;

    &:last-child {
      // margin-left: auto;
      margin-right: 0;
    }
  }

  &:hover {
    color: $black;
    background-color: $gray-100;
  }

  @include media-breakpoint-up(md) {
    padding: 0.5rem;
    border-width: 0.125rem;

    & > * {
      margin-right: 1.5rem;
    }
  }
}

.ui-search-bar-button__text {
  font-size: 1rem;
  line-height: 1.5;

  @include media-breakpoint-up(md) {
    font-size: 1.25rem;
  }
}

.ui-search-bar-button__button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.625rem;
  height: 2.625rem;
  color: $red;
  border: 1px solid $black;
  border-radius: 0.125rem;
  @include transition('color');

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }

  &--search {
    color: $white;
    background-color: $red;
    @include transition('background-color');
  }

  @include media-breakpoint-up(md) {
    width: 4.25rem;
    height: 4.25rem;
    border-width: 0.125rem;
    border-radius: 0.25rem;

    svg {
      width: 2rem;
      height: 2rem;
    }
  }
}
</style>
